export default "__VITE_ASSET__DshP4cfD__"